<template>
    <teleport to="body">
        <TransitionRoot as="template" :show="show" scroll-region>
            <Dialog as="div" :class="[ignoreDarkMode ? '' : { 'dark': store.state.global.isDark }]" class="fixed z-10 inset-0 overflow-y-auto">
                <DialogPanel>
                    <div class="flex items-center justify-center min-h-screen text-center sm:block sm:p-0 sm:w-11/12 m-0 w-full sm:m-auto p-4 sm:p-0">
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="close"/>
                        </TransitionChild>
                        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <div :class="{ 'p-4 sm:p-8': padding }" :style="'max-width: ' + width + 'px'" class="inline-block align-bottom rounded-lg text-left overflow-scroll shadow-xl transform transition-all sm:align-middle w-full transition duration-500 ease-in-out bg-gray-950/90 dark:text-white">
                                <div v-if="icon" class="my-3 mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-800 dark:bg-racing-stars-yellow">
                                    <component :class="{'p-8 ': !padding}" :is="icon" class="h-6 w-6 text-center text-white dark:text-gray-800" aria-hidden="true" />
                            </div>
                            <div v-if="title || subtitle" class="text-center">
                                <DialogTitle as="h3" :class="{'p-4': !padding}" class="text-lg leading-6 font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white">
                                    {{ title }}
                                </DialogTitle>
                                <div v-if="subtitle" class="mt-2 transition duration-500 ease-in-out dark:text-white">
                                    <p v-text="subtitle" :class="{'p-8 pb-0': !padding}" class="text-sm text-gray-500 transition duration-500 ease-in-out dark:text-white" />
                                </div>
                            </div>
                            <slot />
                        </div>
                     </TransitionChild>
                    </div>
                </DialogPanel>
            </Dialog>
        </TransitionRoot>
    </teleport>
</template>
<script>
import { onMounted, onUnmounted } from "vue";
import { Dialog, DialogOverlay, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/outline'
import { useStore } from 'vuex'

export default {
    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            default: false
        },
        closeable: {
            type: Boolean,
            default: true
        },
        ignoreDarkMode: false,
        icon: {},
        padding: Boolean,
        title: String,
        subtitle: String,
        width: {
            type: String,
            default: '400'
        }
    },

    watch: {
        show: {
            immediate: true,
            handler: (show) => {
                if (show) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = null
                }
            }
        }
    },

    setup(props, { emit }) {
        const store = useStore()

        const close = () => {
            if (props.closeable) {
                emit('close')
            }
        }

        const closeOnEscape = (e) => {
            if (e.key === 'Escape' && props.show) {
                close()
            }
        }

        onMounted(() => document.addEventListener('keydown', closeOnEscape))
        onUnmounted(() => {
            document.removeEventListener('keydown', closeOnEscape)
            document.body.style.overflow = null
        })

        return {
            close,
            store,
        }
    },

    computed: {

    },

    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogPanel,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
    }
}

</script>
